import React, { useEffect, useState } from 'react';
import DeletableChips from '../Chip/DeletableChip';
import { useDispatch, useSelector } from 'react-redux';
import { setFilterDataState } from '../../modules/filter/filterAction';
import { RESET_DATE_RANGE, RESET_SELECTED_MONTH_RANGE } from '../../constants';
import { cardComponentCollapse } from '../../modules/cardState/cardAction';

function GenericFilterChip(props) {
  const state = useSelector((state) => state.filterState);

  const dispatch = useDispatch();

  const [activeFiltersArray, setActiveFilterArray] = useState([]);
  const [filterData, setFilterData] = useState(state);

  const handleDeleteActiveFilter = async (key) => {
    if (key === 'dateRange') {
      setFilterData({
        ...filterData,
        startDate: '',
        endDate: '',
      });
      dispatch({
        type: RESET_DATE_RANGE,
      });
    } else if (key === 'monthRange') {
      setFilterData({
        ...filterData,
        monthRange: '',
      });
      dispatch({
        type: RESET_SELECTED_MONTH_RANGE,
      });
    } else if (key === 'employeeName') {
      setFilterData({
        ...filterData,
        employeeName: '',
        employeeId: '',
      });
    } else if (key === 'projectName') {
      setFilterData({
        ...filterData,
        projectName: '',
        projectId: '',
      });
    } else if (key === 'leaveName')
      setFilterData({
        ...filterData,
        leaveName: '',
        leaveId: '',
      });
    else {
      setFilterData({
        ...filterData,
        [key]: '',
      });
    }
    dispatch(cardComponentCollapse());
  };

  const getActiveFilterArray = () => {
    let startDate = null;
    let endDate = null;
    let activeFiltersArray = [];
    Object.entries(state).map((entry) => {
      if (entry[1] !== '' && entry[1] !== undefined) {
        if (entry[0] === 'employeeId') return;
        if (entry[0] === 'projectId') return;
        if (entry[0] === 'leaveId') return;
        if (entry[0] === 'isUpdatedByAdmin') {
          if (entry[1] === true) entry[1] = 'Updated by HR';
          else return;
        }
        if (entry[0] === 'isUpdatedByHr') {
          if (entry[1] === true) entry[1] = 'Updated by HR';
          else return;
        }
        if (entry[0] === 'appraisal') {
          if (entry[1] === true) entry[1] = 'Is Appraisable';
          else return;
        }
        if (entry[0] === 'startDate') {
          startDate = entry[1];
          return;
        }
        if (entry[0] === 'endDate') {
          endDate = entry[1];
          return;
        }
        if (entry[0] === 'status') {
          let temp = entry[1];
          entry[1] = temp;
        }
        if (entry[0] === 'wfhStatus') {
          let temp = entry[1];
          entry[1] = temp;
        }
        activeFiltersArray.push([entry[0], entry[1]]);
      }
    });
    if (startDate !== null) {
      activeFiltersArray.push(['dateRange', startDate + ' - ' + endDate]);
    }
    return activeFiltersArray;
  };

  useEffect(() => {
    dispatch(setFilterDataState(filterData));
  }, [filterData]);

  useEffect(() => {
    setActiveFilterArray(getActiveFilterArray);
    setFilterData(state);
  }, [state]);

  const monthsArray = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const monthRangeArrayToString = (monthRange) => {
    if (monthRange[0] === monthRange[2] && monthRange[1] === monthRange[3])
      return `${monthsArray[monthRange[0] - 1]} ${monthRange[1]}`;
    else if (monthRange[1] === monthRange[3])
      return `${monthsArray[monthRange[0] - 1]} - ${monthsArray[monthRange[2] - 1]} ${monthRange[3]}`;
    return `${monthsArray[monthRange[0] - 1]} ${monthRange[1]} - ${monthsArray[monthRange[2] - 1]} ${monthRange[3]}`;
  };

  return (
    <>
      {activeFiltersArray.map((filter) => {
        return (
          <DeletableChips
            key={filter[0]}
            chipValue={
              filter[0] === 'monthRange'
                ? monthRangeArrayToString(filter[1])
                : filter[1]
            }
            chipKey={filter[0]}
            deleteChip={handleDeleteActiveFilter}
          />
        );
      })}
    </>
  );
}

export default GenericFilterChip;
